module.exports = __webpack_public_path__ + "static/media/video.fbf5a509.m4v";